module.exports = __webpack_public_path__ + "static/partner6-028edab46dc8ce38add2d6034712dfbc.png";